import type { PageHeaderActionsProps } from './PageHeader.types';

/**
 * Right-hand action group. The header owns only its placement and spacing;
 * what goes inside is entirely the caller's.
 */
export function PageHeaderActions(props: PageHeaderActionsProps) {
  return (
    <div data-testid="page-header-actions" className="flex shrink-0 items-center gap-xs">
      {props.children}
    </div>
  );
}
